module.exports = __webpack_public_path__ + "static/lawadvisor-ventures--loop-02-c6442b213527511e92c8b04b3e3f2378.mp4";